import { render, staticRenderFns } from "./MainHeaderSimple.vue?vue&type=template&id=285624d4&scoped=true"
import script from "./MainHeaderSimple.vue?vue&type=script&lang=js"
export * from "./MainHeaderSimple.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderSimple.vue?vue&type=style&index=0&id=285624d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285624d4",
  null
  
)

export default component.exports